export const TOKEN_ROLE_FIELD = 'tokenRole';
export const NAME_FIELD = 'name';
export const DESCRIPTION_FIELD = 'description';
export const TOKEN_ID_FIELD = 'tokenId';
export const LAST_ACCESSED_FIELD = 'lastAccessed';
export const EXPIRY_FIELD = 'expiry';
export const CREATED_AT_FIELD = 'createdAt';
export const CREATED_BY_FIELD = 'createdBy';
export const CREATED_BY_ID_FIELD = 'createdById';
export const TOKEN_FIELD = 'token';
